// extracted by mini-css-extract-plugin
export default {"about":"About_about__A+xaB","text":"About_text__IMfhu","text__list":"About_text__list__rYzw1","img":"About_img__umIEV"};